import React, { useState, useEffect } from 'react'
import { AssignmentIndOutlined } from '@material-ui/icons'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { api } from 'services';
import BootstrapTable from 'react-bootstrap-table-next';
import { Trans } from 'react-i18next';
import Pagination from 'react-js-pagination';
import { DebounceInput } from 'react-debounce-input';
import moment from 'moment/moment';
import Loading from 'components/Loading';

export default function() {
  const defaultFilters = { 
    per_page: 10, 
    page: 1,
    __search: "",
  };
  
  const [filters, setFilters] = useState(defaultFilters);
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchErrors()
  }, [filters])

  const fetchErrors = () => {
    setIsLoading(true)
    api.get('hubspot-errors-log', {
      params: filters
    })
    .then(({ data: response }) => {
      setData(response.data.map(error => ({ 
        ...error, 
        updated_at: moment(error.updated_at, 'YYYY-MM-DD HH:mm:ss')
          .format("DD/MM/YYYY HH:mm:ss")
      })))
      setPagination(response.pagination)
    })
    .finally(() => setIsLoading(false))
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handlePageChange = page => handleFilterChange({ page })

  return (
    <Container fluid>
      <Row className="mt-4">
        <AssignmentIndOutlined className="icon-title" />
        <h5 className="title-dashboard">Hubspot Log</h5>
      </Row>
      <Row>
        <Card.Body
          className={'card-dashboard shadow bg-white rounded m-2 col-12'}
        >
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label>Registros por página:</Form.Label>
                <Form.Control
                  as="select"
                  value={filters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            {/* <Col md={6}>
              <Form.Group>
                <Form.Label>Pesquisar</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={filters.__search}
                  onChange={({ target }) => {
                    handleFilterChange({ __search: target.value, page: 1 })
                  }}
                />
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            <Col>
              {isLoading ? (<Loading page />) : (
                <BootstrapTable 
                  style={{ width: '100px' }}
                  id="table"
                  className="font-10"
                  keyField="id"
                  data={data}
                  columns={[
                    {
                      dataField: 'hubspot_headquarter_id',
                      text: 'Revenda ID Hubspot',
                      headerStyle: {
                        textAlign: 'center',
                      },
                      style: {
                        textAlign: 'center',
                      },
                    }, {
                      dataField: 'error',
                      text: 'Erro',
                      headerStyle: {
                        textAlign: 'center',
                      },
                      style: {
                        textAlign: 'center',
                      },
                    }, {
                      dataField: 'updated_at',
                      text: 'Data',
                      headerStyle: {
                        textAlign: 'center',
                      },
                      style: {
                        textAlign: 'center',
                      },
                    }
                  ]}
                  bordered
                  striped
                  condensed
                />
              )}
              <Row>
                <Col xs="12" md="6">
                  <Trans i18nKey="label:interpolateShowingRecords">
                    Showing {{ from: pagination.from || '0' }} to{' '}
                    {{ to: pagination.to || '0' }} from{' '}
                    {{ total: pagination.total }} records
                  </Trans>
                </Col>
                <Col xs="12" md="6" className="d-flex justify-content-end">
                  <Pagination
                    activePage={pagination.current_page ?? 0}
                    itemsCountPerPage={parseInt(pagination.per_page ?? 0)}
                    totalItemsCount={pagination.total ?? 0}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                    prevPageText="‹"
                    nextPageText="›"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Row>
    </Container>
  )
}